/* eslint-disable max-lines */
import React, { useContext, useEffect } from 'react';
import { Formik, Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { ClinicInput, CalendarInput, AutosizeTextarea, SubmitButton, TimeSelect } from '../UI';
import { Grid, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    createAppointment,
    setSelectedAppointment,
    editAppointment,
    setEditedAppointment
} from '../../redux/Appointment/AppointmentAction';
import { getGenericList } from '../../redux/General/GeneralAction';
import { PropTypes } from 'prop-types';
import moment from 'moment-timezone';
import { phone } from '../../utils/validationRegex';
import MessagesContext from '../../contexts/messagesContext';
import { getClinicId, getClinicStartTime, getClinicTimeZone } from '../../utils/storage';
import { withRouter } from 'react-router-dom';
const styles = makeStyles({
    submitBtnContainer: {
        paddingTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '20px'
    },
    optionalSubmitBtnContainer: {
        padding: '50px 0 20px',
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'sticky',
        bottom: '0',
        width: '100%'
    },
    dateTimeContainer: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'baseline'
    },
    datePickerContainer: {
        width: '180px',
        marginInlineEnd: '10px'
    },
    header: {
        marginTop: '0',
        marginBottom: '24px'
    }
});
const AppointmentForm = ({ patientId, triggerSynchronousAdmission, ...props }) => {
    const { messages } = useContext(MessagesContext);
    const classes = styles();

    const createAppointmentParam = (values) => {
        const clinicStartTime = getClinicStartTime();
        const timezone = getClinicTimeZone();
        let params = {};
        if (props.selectedAppointment?.id) {
            params = { ...props.selectedAppointment };
        }
        if (!values) {
            const { selectedHour, selectedDate } = props;
            let date = '';
            if (selectedHour && selectedDate) {
                date = selectedDate + ' ' + selectedHour;
            } else if (selectedDate) {
                date = selectedDate + ' ' + clinicStartTime;
            }
            params = {
                ...params,
                ...{
                    patient: patientId ? patientId : +props.match.params?.id,
                    clinic_id: getClinicId(),
                    has_appointed_time: selectedHour ? true : false,
                    appointed: date ? moment(date)?.tz(timezone)?.format() : ''
                }
            };
        } else {
            const { phoneNumber, initialComplaint, appointedTime, appointed } = values;
            let date;
            if (appointedTime) {
                date = appointed + ' ' + appointedTime;
            } else {
                date = appointed + ' ' + clinicStartTime;
            }
            params = {
                ...params,
                ...{
                    patient: patientId ? patientId : +props.match.params?.id,
                    clinic_id: getClinicId(),
                    phone_number: phoneNumber ? phoneNumber : '',
                    initial_complaint: initialComplaint ? initialComplaint : '',
                    has_appointed_time: appointedTime ? true : false,
                    appointed: moment(date).tz(timezone)?.format()
                }
            };
        }

        return params;
    };
    const handleSynchronousAdmission = (isValid) => {
        if (!isValid) {
            return;
        }
        triggerSynchronousAdmission();
    };

    const handleChange = (values) => {
        props.setEditedAppointment(createAppointmentParam(values));
    };

    const ChangeValues = () => {
        const { values } = useFormikContext();
        useEffect(() => {
            handleChange(values);
        }, [values.appointed, values.appointedTime]);
        return null;
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                phoneNumber: props.selectedAppointment?.phone_number
                    ? props.selectedAppointment.phone_number
                    : '',
                initialComplaint: props.selectedAppointment?.initial_complaint
                    ? props.selectedAppointment.initial_complaint
                    : '',
                appointed: props.selectedAppointment?.appointed
                    ? moment(props.selectedAppointment.appointed).format('YYYY-MM-DD')
                    : props?.selectedDate
                    ? props?.selectedDate
                    : moment(new Date()).format('YYYY-MM-DD'),
                appointedTime: props.selectedAppointment?.appointed
                    ? moment(props.selectedAppointment.appointed).format('HH:mm')
                    : props.selectedHour
                    ? props.selectedHour.toString()
                    : ''
            }}
            validationSchema={Yup.object({
                phoneNumber: Yup.string().matches(phone, messages.validations.incorrectValue),
                appointed: Yup.date().required(messages.validations.required)
            })}
            onSubmit={async (values) => {
                const appointment = createAppointmentParam(values);
                let response;
                if (props.selectedAppointment?.id) {
                    response = await props.editAppointment(
                        props.selectedAppointment?.id,
                        appointment
                    );
                } else {
                    response = await props.createAppointment(appointment);
                }
                if (response?.status === 200) {
                    props.setSelectedAppointment(null);
                    props.closeModal();
                }
            }}
        >
            {({ errors, touched, values, setFieldValue, isSubmitting, isValid }) => (
                <Form>
                    <h2 className={classes.header}>
                        {props.selectedAppointment?.id
                            ? messages.editAppointment
                            : messages.addNewAppointment}
                    </h2>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <div className={classes.dateTimeContainer}>
                                <div className={classes.datePickerContainer}>
                                    <CalendarInput
                                        width="100%"
                                        label={messages.date}
                                        name="appointed"
                                        value={values.appointed}
                                        errors={errors.appointed && touched.appointed}
                                        setValue={(value) => {
                                            setFieldValue('appointed', value);
                                        }}
                                    />
                                </div>
                                <TimeSelect
                                    value={values.appointedTime}
                                    setTime={(time) => {
                                        setFieldValue('appointedTime', time);
                                    }}
                                    label={messages.time}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ClinicInput name="phoneNumber" label={messages.phoneNo} type="text" />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <AutosizeTextarea
                                name="initialComplaint"
                                label={messages.reasonOfReferral}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} className={classes.optionalSubmitBtnContainer}>
                            <SubmitButton
                                secondary={true}
                                handleClick={() => handleSynchronousAdmission(isValid)}
                                submitText={
                                    props.selectedAppointment
                                        ? messages.editAppointmentSynchAdmit
                                        : messages.submitAppointmentSynchAdmit
                                }
                            />
                            <SubmitButton
                                isSubmitting={isSubmitting}
                                submitText={
                                    props.selectedAppointment?.id
                                        ? messages.editAppointment
                                        : messages.reserveAppointment
                                }
                            />
                        </Grid>
                        <div></div>
                    </Grid>
                    <ChangeValues />
                </Form>
            )}
        </Formik>
    );
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            createAppointment,
            getGenericList,
            setSelectedAppointment,
            editAppointment,
            setEditedAppointment
        },
        dispatch
    );
const mapStateToProps = (state) => {
    return {
        selectedDate: state.appointment?.date?.selected,
        selectedHour: state.appointment?.date?.hour,
        selectedAppointment: state.appointment.selectedAppointment
    };
};
AppointmentForm.propTypes = {
    classes: PropTypes.object,
    createAppointment: PropTypes.func,
    match: PropTypes.object,
    insuranceTypes: PropTypes.array,
    getGenericList: PropTypes.func,
    triggerSynchronousAdmission: PropTypes.func,
    selectedDate: PropTypes.string,
    selectedHour: PropTypes.number,
    patientId: PropTypes.string,
    closeModal: PropTypes.func,
    setSelectedAppointment: PropTypes.func,
    selectedAppointment: PropTypes.object,
    editAppointment: PropTypes.func,
    setEditedAppointment: PropTypes.func
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppointmentForm));
